import { render } from "./FeatInfoArticle.vue?vue&type=template&id=15dcd6c2&scoped=true"
import script from "./FeatInfoArticle.vue?vue&type=script&lang=js"
export * from "./FeatInfoArticle.vue?vue&type=script&lang=js"

import "./FeatInfoArticle.vue?vue&type=style&index=0&id=15dcd6c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-15dcd6c2"

export default script